var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-bundle-builder" }, [
    _c("div", { staticClass: "c-bundle-builder__header" }, [
      _c("h3", { staticClass: "c-bundle-builder__header__title" }, [
        _vm._v("Váš zvýhodnený set"),
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "c-btn", on: { click: _vm.resetBundleBuilderState } },
        [
          _c("i", { staticClass: "ico ico-close" }),
          _vm._v("\n      Vymazať set\n    "),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-btn c-btn--primary c-custom-bundle-trigger-close",
          on: { click: _vm.closePanel },
        },
        [
          _c("i", { staticClass: "ico ico-chevron-left" }),
          _vm._v("\n      Zbaliť\n    "),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-bundle-builder__main" },
      _vm._l(_vm.bundleSteps, function (bundleStep, idx) {
        return _c(
          "div",
          {
            key: bundleStep.id,
            staticClass: "c-bundle-builder-step",
            class: {
              "is-active": idx + 1 === _vm.bundleBuilderState.currentStep,
              "is-picked": _vm.bundleBuilderState.steps[idx + 1].product,
            },
          },
          [
            _c("div", { staticClass: "c-bundle-builder-step__header" }, [
              _c(
                "div",
                { staticClass: "c-bundle-builder-step__header__icon" },
                [
                  _vm.bundleBuilderState.steps[idx + 1].product
                    ? _c("i", { staticClass: "ico ico-check" })
                    : _c("span", [
                        _vm._v(
                          "\n            " + _vm._s(idx + 1) + "\n          "
                        ),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-bundle-builder-step__header__text" },
                [
                  _c(
                    "h5",
                    { staticClass: "c-bundle-builder-step__header__title" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(bundleStep.title) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.bundleBuilderState.steps[idx + 1].required &&
                  !_vm.bundleBuilderState.steps[idx + 1].product
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "c-bundle-builder-step__header__required-msg",
                        },
                        [_vm._v("\n            povinná položka\n          ")]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.bundleBuilderState.steps[idx + 1].product
              ? _c("div", { staticClass: "c-bundle-builder-step__product" }, [
                  idx + 1 === _vm.lastStepWithProduct
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "c-btn c-btn--link c-step-product__remove",
                          on: {
                            click: function ($event) {
                              return _vm.removeStepProduct(idx + 1)
                            },
                          },
                        },
                        [_c("i", { staticClass: "ico ico-close" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "c-step-product__image",
                    attrs: {
                      src: _vm.thumbnail(
                        _vm.bundleBuilderState.steps[idx + 1].product.image,
                        "lg"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "c-step-product__name" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.bundleBuilderState.steps[idx + 1].product.name
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-step-product__prices" }, [
                    _c("span", { staticClass: "c-step-product__price" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.formatPrice(
                              _vm.bundleBuilderState.steps[idx + 1].product
                                .price *
                                _vm.bundleBuilderState.steps[idx + 1].product
                                  .quantity
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "c-step-product__price--old" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.formatPrice(
                              _vm.bundleBuilderState.steps[idx + 1].product
                                .old_price *
                                _vm.bundleBuilderState.steps[idx + 1].product
                                  .quantity
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "c-step-product__quantity" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            parseFloat(
                              (
                                _vm.bundleBuilderState.steps[idx + 1].product
                                  .quantity *
                                _vm.bundleBuilderState.steps[idx + 1].product
                                  .custom_mvm_bal
                              ).toFixed(3)
                            )
                          ) +
                          " "
                      ),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.bundleBuilderState.steps[idx + 1].product
                              .custom_sell_mj
                          ),
                        },
                      }),
                      _vm._v(
                        " x\n            " +
                          _vm._s(
                            _vm.formatPrice(
                              _vm.bundleBuilderState.steps[idx + 1].product
                                .price_m2_vat
                            )
                          ) +
                          "/"
                      ),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.bundleBuilderState.steps[idx + 1].product
                              .custom_sell_mj
                          ),
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "c-bundle-builder__footer" }, [
      _vm.totals
        ? _c("div", { staticClass: "c-bundle-builder__totals" }, [
            _c(
              "div",
              {
                staticClass:
                  "c-bundle-builder__totals__price c-bundle-builder__totals__total",
              },
              [
                _c("p", [_vm._v("Spolu")]),
                _vm._v(
                  "\n\n        " +
                    _vm._s(_vm.formatPrice(_vm.totals.total)) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "c-bundle-builder__totals__price c-bundle-builder__totals__discount",
              },
              [
                _c("p", [_vm._v("Ušetrili ste")]),
                _vm._v(
                  "\n\n        " +
                    _vm._s(_vm.formatPrice(_vm.totals.discount)) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "c-bundle-builder__totals__price c-bundle-builder__totals__final",
              },
              [
                _c("p", [_vm._v("Vaša cena")]),
                _vm._v(
                  "\n\n        " +
                    _vm._s(_vm.formatPrice(_vm.totals.final)) +
                    "\n      "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-btn c-btn--cart",
          class: { "is-disabled": !_vm.requiredPicked },
          attrs: { disabled: !_vm.requiredPicked },
          on: {
            click: function ($event) {
              return _vm.addBundleToCart()
            },
          },
        },
        [
          _c("i", { staticClass: "ico ico-cart" }),
          _vm._v("\n      Vložiť vlastný set do košíka\n    "),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }